import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../generic-components/Button';

export interface SettingsItemProps {
  title: string;
  value: string;
  onEditClick?: () => void;
  editButtonTitle?: string;
  showEditButton?: boolean;
  isLast?: boolean;
  icon: ReactNode;
  editButtonId: string;
}

export const SettingsItem = ({
  title,
  value,
  icon,
  isLast = false,
  editButtonId,
  onEditClick,
  editButtonTitle = useTranslation().t('ACCOUNT_SETTINGS.EDIT_BUTTON'),
  showEditButton = true,
}: SettingsItemProps) => (
  <div className={`flex flex-row items-center gap-[8px] py-[10px]  ${!isLast && 'border-b-bw03 border-b-[1px]'}`}>
    <div className='text-bw07 h-[24px] mr-[8px]'>{icon}</div>
    <div className='flex flex-col w-full'>
      <p className='text-bw08 text-[16px] font-metricRMedium'>{title}</p>
      <p className='text-bw07 text-[16px] font-metricR' id={`value-${editButtonId}`}>{value}</p>
    </div>
    {showEditButton && (
      <Button
        className='font-metricR text-action03 text-[16px] py-[4px] px-[10px] w-fit hover:bg-action00 hover:rounded-md rounded-md  whitespace-nowrap'
        id={`settings-edit-button-${editButtonId}`}
        title={editButtonTitle}
        onClick={onEditClick}
      />
    )}
  </div>
);
